import { message } from 'antd'
import { DEFAULT_USER_NAME, MESSAGE } from '../utils/constant'

export const serializeForm = data => {
	let rs = ''
	for (const k in data) {
		rs += `${k}=${encodeURIComponent(data[k])}&`
	}
	return rs.substr(0, rs.length - 1) // remove '&' at the end
}
export function removeNullFieldInObj(data) {
	const rs = { ...data }
	Object.keys(rs).map(key => {
		if (rs[key] === null) {
			delete rs[key]
		}
	})
	return rs
}
export const deleteDataInArray = (prevData, newItem) => {
	if (!prevData) {
		return []
	}

	return prevData.filter(item => item.id !== newItem.id)
}

export function formatDayMonthYear(time) {
	let d = time ? new Date(time) : new Date()
	const day = d.getDate()
	const month = d.getMonth() + 1
	const year = d.getFullYear()

	return [day, month, year].join('/')
}

export function formatDateTime(time) {
	let d = time ? new Date(time) : new Date()
	const day = d.getDate()
	const month = d.getMonth() + 1
	const year = d.getFullYear()
	const h = d.getHours()
	const m = d.getMinutes()
	const s = d.getSeconds()

	return [day, month, year].join('/') + ' ' + [h, m, s].join(':')
}

export const showMessageError = msg => {
	const text =
		msg != null && String(msg).trim() !== '' ? String(msg) : MESSAGE.ERROR
	if (text.length > 500) {
		message.error(MESSAGE.ERROR)
	} else {
		message.error(text)
	}
}

export const showMessageWarning = msg => {
	message.warning(msg || MESSAGE.ERROR)
}

export const showMessageSuccess = msg => {
	message.success(msg || MESSAGE.SUCCESS)
}

export const showMessageInfo = msg => {
	message.info(msg || MESSAGE.SUCCESS)
}

export const formatNumber = num => {
	if (num === 0) {
		return num
	}
	if (!num) {
		return ''
	}
	if (Number.isInteger(num)) {
		return num?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	}
	let string = num.toString().split('.')
	string[0] = string[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	return string.join('.')
}

/** Fixed decimal places with grouping, e.g. 1234.5 → "1,234.50" */
export const formatDecimal = (num, fractionDigits = 2) => {
	if (num === null || num === undefined || Number.isNaN(num)) {
		return ''
	}
	return Number(num).toLocaleString('en-US', {
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits,
	})
}

export const updateDataInArray = (prevData, newItem, key = 'id') => {
	if (!prevData) {
		return [newItem]
	}

	return prevData.map(item => {
		const newData = removeNullFieldInObj(newItem)
		return item[key] === newItem[key] ? { ...item, ...newData } : item
	})
}

export const addDataToArray = (prevData, newItem, isAddToEnd = true) => {
	if (!prevData) {
		return [newItem]
	}

	if (isAddToEnd) {
		return [...prevData, newItem]
	} else {
		return [newItem, ...prevData]
	}
}

export const handleSubmitCb = (isSuccess, rs) => {
	if (isSuccess) {
		showMessageSuccess()
	} else {
		showMessageError(rs)
	}
}

export const getUserDisplayName = user => {
	if (user) {
		let rs = [user.lastName, user.firstName].join(' ')
		if (!rs.trim()) {
			if (user.authName && user.authName.length < 50) {
				rs = user.authName
			}
		}
		return rs.trim() || DEFAULT_USER_NAME
	}
	return DEFAULT_USER_NAME
}

export const formatMoney = value => {
	// const lang = language === LANGUAGE.VI ? 'vi' : 'en-US';
	return value.toLocaleString('vi', {
		style: 'currency',
		currency: 'VND',
	})
}
